import { Button, ModalPanel, Title } from "dash-styled"
import React, { FC, FormEvent, useCallback, useMemo, useState } from "react"
import { DelimitedTextInput } from "../../../../../Common/DelimitedTextInput/DelimitedTextInput"

interface WorkerAddModalProps {
    isSaving: boolean
    onClose: () => void
    onSubmit: (emails: string[]) => void
}

export const WorkerAddModal: FC<WorkerAddModalProps> = ({
    isSaving,
    onClose,
    onSubmit
}) => {
    const [emails, setEmails] = useState<string[] | undefined>(undefined)
    const validEmails = useMemo(
        () => emails?.filter(email => email.trim() !== "") ?? [],
        [emails]
    )
    const handleSubmit = useCallback(
        (e: FormEvent<HTMLFormElement>) => {
            e.preventDefault()

            if (validEmails.length > 0) {
                onSubmit(validEmails)
            }
        },
        [onSubmit, validEmails]
    )

    return (
        <ModalPanel onClose={onClose} className="max-w-2xl w-full">
            <Title variant="heading2" weight="semibold" component="h2">
                Add new human worker
            </Title>
            <form onSubmit={handleSubmit}>
                <DelimitedTextInput
                    className="mb-1"
                    label="Email address"
                    variant="bordered"
                    newlineExpanding={true}
                    placeholder="e.g. your_email@company.com, another_email@company.com"
                    value={emails}
                    onChange={setEmails}
                />
                <Button
                    type="submit"
                    className="w-auto mt-8 px-8"
                    disabled={isSaving || validEmails.length === 0}
                >
                    {isSaving ? "Adding..." : "Add"}
                </Button>
            </form>
        </ModalPanel>
    )
}
